/**
 * Classe que gerencia a exibição e eventos da funcionalidade de
 * atribuir motorista à rota.
 *
 * @author: Adalto Junior
 * DATE: 18/03/2013
 *
 */


Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.AssignDriver = function ({
  modalContentSelector = '#Route .popupFormContainer',
  routeId = App.Forms.Route.form.fields.id.getValue(),
  scopeBlock = '#Route form.MonetUIForm.Route',
  selector = '#Route #form_and_grid',
  successCallback,
  afterRemoveItems
} = {}) {

    this.modalForm = null;
    this.isPending = false;

    this.showAssignDriver = function () {

        this.modalForm.showModalForm();

    };

    this.addFormToModalContent = () => {

        const modalContent = document.querySelector(modalContentSelector);

        if (modalContent) {

            try {

                const contentToModal = this.constructFormAssignDriver(routeId);

                modalContent.appendChild(contentToModal.html);

                const lookupContainer = modalContent.querySelector('.form-horizontal');

                lookupContainer.appendChild(contentToModal.field.rootEl);

                this.populateListDrivers(routeId, contentToModal.field);
                this.addEventListenners();

            } catch (e) {
              const error = new Monet.Exception.ReturnError(this, "No add form to modal.");
              error.console();
            }


        } else {

            const exception = new Monet.Exception.ReturnError(this, "No modal to add form.");
            exception.console();

        }

    };

    this.buildTemplate = function (routeIdValue) {
        var layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingDriver.btnSave"),
                                                "name": "btn_save_assign_driver",
                                                "id": "btn_save_assign_driver",
                                                "class": "btn",
                                                "style": "float:right;"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingDriver.btnExit"),
                                                "name": "btn_exit_assign_driver",
                                                "id": "btn_exit_assign_driver",
                                                "class": "btn"
                                            }

                                        }
                                    ],
                                    "attributes": {
                                        "style": "position:relative; float:left; width: 100%",
                                        "class": "standard-form-buttons"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "monetInlineAlerContainer"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "hidden",
                                                "id": "route_id",
                                                "name": "route.id",
                                                "value": routeIdValue,
                                                "class": "modelAttribute"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span8"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "html": "",
                                            "attributes": {
                                                "class": "form-horizontal"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span4"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "form_assign_driver"
                    }
                }
            ]
        };

        return ( new Monet.UI.LayoutGenerator(layout) ).render();

    };

    this.constructFormAssignDriver = function (routeId) {

        try {

            var field = new Monet.UI.Fields.PowerLookupList();

            field.setId('driver');
            field.setNameSpace('driver');
            field.setLookUpEntity('Driver');
            field.setDisplayKey('name');
            field.setTextLabel(Monet.I18n.getResourcesByKey('Route.AssingDriver.label.driver'));
            field.setInputName('name');
            field.render();

            return {
                html: this.buildTemplate(routeId),
                field: field
            };

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "No form to assign driver.");
            error.console();
        }

    };

    this.populateListDrivers = async function (routeId, lookupField) {
        try {
            var route = new App.Routers.Route();
            const dataToLookup = [];

            var drivers = await route.getDriversByRoute(routeId);
            var driversTotal = drivers.length;

            if (driversTotal) {
                for (var i = 0; i < driversTotal; i++) {
                    dataToLookup.push(drivers[i].driver);
                }
            }

            lookupField.setValue(dataToLookup);

            drivers.forEach(driverData => {
                const trashIcon = document.querySelector('.item_lookuplist_driver_' + driverData.driver.id + ' .del_item_added');
                trashIcon.addEventListener('click', () => {
                    var model = new App.Models.RouteDriverAssignment();
                    model.unassignToRoute(
                      {
                        assignmentId: driverData.id
                      },
                      () => {
                        afterRemoveItems?.();
                      }
                    );
                });
            });

            const utils = new Greenmile.Route.ModalUtils();
            utils.removeAllActionListener(
              lookupField,
              drivers,
              'driver',
              false,
              () => {
                afterRemoveItems?.();
              }
            );

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "No populate list drivers.");
            error.console();
        }
    };


    this.assignDriverToRoute = () => {
      const btnSave = document.querySelector("#form_assign_driver #btn_save_assign_driver");
      const assignToRouteCallback = () => {
        this.modalForm.closeModalWindow();
        successCallback?.();
        btnSave.removeAttribute('disabled');
      };

      if (this.validateForm()) {
        btnSave.setAttribute('disabled', 'disabled');
        try {
          const selectorDrivers = "#form_assign_driver #driver_list input[type='hidden']";
          const drivers = document.querySelectorAll(selectorDrivers);
          const totalDrivers = drivers.length;
          const model = new App.Models.RouteDriverAssignment();
          const listDrivers = []

          for (let i = 0; i < totalDrivers; i++) {
            const driver = drivers[i];
            const data = {
              route: {
                id: routeId
              },
              driver: {
                id: driver.value
              }
            };

            listDrivers.push(data)
          }

          model.assignToRouteInBatch({ list: listDrivers }, assignToRouteCallback, () => {
            btnSave.removeAttribute('disabled');
          });
        } catch (e) {
          const error = new Monet.Exception.ReturnError(
            this,
            "No assign driver to route."
          );
          error.console();
          btnSave.removeAttribute('disabled');
        }
      }
    };

    this.addEventListenners = function () {

        try {

            var that = this;

            var btnSave = document.querySelector("#form_assign_driver #btn_save_assign_driver");
            var btnExit = document.querySelector("#form_assign_driver #btn_exit_assign_driver");

            btnSave.onclick = function () {

                that.assignDriverToRoute()

            };

            btnExit.onclick = function () {

                that.modalForm.closeModalWindow();

            };

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No add event listenner to form.");
            error.console();

        }

    };

    this.validateForm = function () {

        var isValid = true;

        try {

            var fields = document.querySelectorAll("#form_assign_driver #driver_list input[type='hidden']");

            if (!fields.length) {

                isValid = false;

                var errorMessages = {
                    errorMessages: [Monet.Form.Messages.mountErrorMessageObject("Route.AssingDriver.driverNotSelected")]
                };

                var monetMessage = new Monet.Form.Messages.InlineMessage();

                monetMessage.setScope("#form_assign_driver");
                monetMessage.setInfoType("error");

                monetMessage.setMessage(errorMessages);

                monetMessage.triggerMessage();
            }

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No validate form.");
            error.console();

        }

        return isValid;
    };

    var init = function (scope) {
        return function (scope) {
            const options = { width: 500, height: 400 };
            const callbacks = {
                onAfterShowModalForm: scope.addFormToModalContent
            };
            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
        }(scope);
    };

    init(this);

};
